import { Box, Stack, Typography } from "@mui/material";
export default function TechStackCard  () {
    return (
    
  <Box 
    sx={{ 
      p: 3, 
      height: "100%",
      borderRadius: "24px", 
      background: "rgba(30, 41, 59, 0.5)", 
      backdropFilter: "blur(10px)",
      border: "1px solid rgba(59, 130, 246, 0.2)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    }}
  >
    <Typography variant="caption" sx={{ color: "#3b82f6", fontWeight: 700, mb: 1, letterSpacing: 1 }}>
      CORE TECH
    </Typography>
    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
      {['React', 'Node.js', 'AWS', 'Python', 'DevSecOps'].map((skill) => (
        <Box 
          key={skill}
          sx={{ 
            px: 1.5, py: 0.5, borderRadius: "8px", 
            bgcolor: "rgba(255,255,255,0.05)", fontSize: "11px", color: "#e6edf3" 
          }}
        >
          {skill}
        </Box>
      ))}
    </Stack>
  </Box>
);
}